import InputNumber from './input-number';
import mapProps from '../scripts/utils/map-props';

export default mapProps([
  'value',
], {
  model: {
    event: 'change',
    prop: 'value',
  },
})(InputNumber);
